<ng-container *ngIf="!(allProductsAlwaysAvailable$ | async)">
  <div class="menu-limit" role="region" aria-label="Menu display options">
    <button
            type="button"
            [class.map-bg]="!(showFullMenu$ | async)"
            [class.list-bg]="(showFullMenu$ | async)"
            class="d-flex align-items-center m-0 p-1 toggle-switch border"
            (click)="menuService.toggleFullMenu()"
            [attr.aria-pressed]="(showFullMenu$ | async)"
            [attr.aria-label]="(showFullMenu$ | async) ? 'Switch to current menu' : 'Switch to full menu'"
            [attr.title]="(showFullMenu$ | async) ? 'Switch to current menu' : 'Switch to full menu'"
            (keydown.enter)="$event.preventDefault(); menuService.toggleFullMenu()">
      <div
              class="d-flex justify-content-center align-items-center toggle-circle"
              [class.map-toggle]="(showFullMenu$ | async)"
              [class.list-toggle]="!(showFullMenu$ | async)"
              aria-hidden="true">
        <i
                class="bi d-flex"
                [ngClass]="(showFullMenu$ | async) ? 'bi-clock' : 'bi-clock-history'"
                aria-hidden="true"></i>
      </div>
    </button>
    <small id="menuToggleLabel" aria-live="polite">{{!(showFullMenu$ | async) ? 'Current' : 'Full'}} Menu</small>
  </div>
</ng-container>